export type ClassName = string | string[] | undefined | false | null;

export function classNames(names: ClassName[]): string {
  return names.filter((n) => n).flatMap((n) => n).join(" ");
}

export function value(defaultValue: number, ...values: (number | undefined)[]): number {
  for (const v of values) {
    if (v != undefined) {
      return v;
    }
  }
  return defaultValue;
}

export type OnClickEvent = () => void;
export type OnChangeEvent<T> = (value: T) => void;
